import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { ITable } from '@common/models/table';
import { IContext } from '@context/models/context';
import { IColumnDefinition } from '@common/models/column-definition';
import { IResizedColumn } from '@common/models/table';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { ContextToHttpParamsService } from '@context/services/context-to-params.service';
import { RemittanceDocument } from '@feature/payments-to-you/models/remittance-document';


@Injectable()
export class PaymentsToYouHttpService {

    constructor(private http: HttpClient, private readonly urlProvider: UrlBuilderService,
        private readonly contextToHttpParamsService: ContextToHttpParamsService) { }

    getPaymentsTableColumns(widgetInstanceId: number): Observable<IColumnDefinition[]> {
        const url = this.urlProvider.getUrl(`payments/${widgetInstanceId}/table/availablecolumns`);
      return this.http
        .get<IColumnDefinition[]>(url).pipe(
          map(table => table || undefined)
        );
    }

    getAllPaymentsTableColumns(): Observable<IColumnDefinition[]> {
        const url = this.urlProvider.getUrl(`payments/table/columns`);
      return this.http
        .get<IColumnDefinition[]>(url).pipe(
          map(table => table || undefined)
        );
    }

    putPaymentsTableColumns(payload: IColumnDefinition[], widgetInstanceId: number): Observable<any> {
        const url = this.urlProvider.getUrl(`payments/${widgetInstanceId}/table/updatecolumns`);
      return this.http
        .put(url, payload, { responseType: 'text' });
    }

    setTableDefaultColumns(widgetInstanceId: number): Observable<any> {
        const url = this.urlProvider.getUrl(`payments/${widgetInstanceId}/table/setdefault`);
      return this.http
        .put(url, [], { responseType: 'text' });
    }

    resizeColumns(payload: IResizedColumn, widgetInstanceId: number): Observable<any> {
        const url = this.urlProvider.getUrl(`payments/${widgetInstanceId}/table/resizecolumns`);
      return this.http
        .put(url, payload, { responseType: 'text' });
    }

    reorderPaymentsTableColumns(payload: string[], widgetInstanceId: number): Observable<any> {
        const url = this.urlProvider.getUrl(`payments/${widgetInstanceId}/table/reordercolumns`);
      return this.http
        .put(url, payload, { responseType: 'text' });
    }

  getInternalPaymentsTable(context: IContext, widgetInstanceId: number): Observable<ITable> {
      const url = this.urlProvider.getUrl(`mojo/payments/${widgetInstanceId}/contextquery`);
      const httpParams = this.contextToHttpParamsService.getParams(context);
    return this.http
        .get<ITable>(url, { params: httpParams }).pipe(
        map(table => table || undefined)
      );
    }

  getExternalPaymentsTable(widgetInstanceId: number, accountRef: number = undefined): Observable<ITable> {
      const url = this.urlProvider.getUrl(`mfs/payments/${widgetInstanceId}/contextquery`);
      let params = new HttpParams();
      if (accountRef !== undefined) { params = params.append('creditorUri', String(accountRef)); }
    return this.http
        .get<ITable>(url, { params: params }).pipe(
        map(table => table || undefined)
      );
  }

  getRemittanceDocument(cashbookUri: number): Observable<RemittanceDocument> {
    const url = this.urlProvider.getUrl(`remittance/${cashbookUri}`);
    return this.http
      .get<RemittanceDocument>(url).pipe(
        map(doc => doc || undefined)
      );
  }

}
